import gql from 'graphql-tag';

export const SHOPIFY_SHOP_QUERY = gql`
query ShopifyShop {
  getShopifyStoreData{
    eligibleForSubscriptions
    isShopConnected
  }
}
`;
